import { motion } from "framer-motion";
import { DownloadButton } from "./DownloadButtons";

const LINES = [
  "Tu n'as pas besoin de vendre le produit.",
  "Tu n'as pas besoin de chercher le fournisseur.",
];

export const CoreMessage = () => {
  return (
    <section className="relative overflow-hidden bg-ink py-24 lg:py-36">
      {/* light beam */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-[600px] w-[800px] -translate-x-1/2 rounded-full bg-brand/25 blur-[140px]" />
        <div className="absolute inset-0 grain opacity-[0.04]" />
      </div>

      <div className="relative mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
        {LINES.map((l, i) => (
          <motion.p
            key={l}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-2xl font-bold leading-tight text-white/40 sm:text-3xl lg:text-4xl"
          >
            {l}
          </motion.p>
        ))}

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 font-display text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-5xl"
        >
          Tu dois simplement détecter le besoin et{" "}
          <span className="text-brand">déposer l'opportunité.</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-10 flex justify-center"
        >
          <DownloadButton testId="core-message-download-cta" label="Télécharger l'application Leadzi CHR" className="px-7 py-3.5 text-base" />
        </motion.div>
      </div>
    </section>
  );
};
